import React from 'react';
import DOMPurify from 'dompurify';
import { contentToHtml } from '../../utils/adfToHtml';

export default function Comment({ comment, onReply }) {
  const { authorName, body, createdAt } = comment;
  const sanitized = DOMPurify.sanitize(contentToHtml(body || ''), { USE_PROFILES: { html: true } });
  const dateStr = createdAt
    ? new Intl.DateTimeFormat(navigator.language, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(createdAt))
    : '';

  return (
    <div className="mb-3 pb-3 border-bottom">
      <div className="d-flex align-items-center flex-wrap gap-2">
        <strong>{authorName}</strong>
        <span className="text-muted small">{dateStr}</span>
        {onReply && (
          <button
            type="button"
            className="btn btn-link btn-sm p-0"
            onClick={() => onReply()}
            aria-label={`Reply to ${authorName}'s comment`}
          >
            Reply
          </button>
        )}
      </div>
      <div className="mt-1" dangerouslySetInnerHTML={{ __html: sanitized }} />
    </div>
  );
}
